import { AuthState } from '@okta/okta-auth-js';

import { RefFuturesContractsMassUpdates } from '../../services/backend/RefFuturesContractsMassUpdates';
import { useBaseApiClient } from '../useBaseApiClient';

export const useRefFuturesContractsMassUpdates: () => RefFuturesContractsMassUpdates<AuthState> =
  () => {
    return useBaseApiClient(RefFuturesContractsMassUpdates);
  };
